<mijn-login-template [title]="'mijn.login.browsercode.herstel.wrapper.title' | apContent" [showExtraContentCard]="false">
    <div class="ap-display-block ap-margin-bottom-4">
        <ap-content key="mijn.login.browsercode.herstel.wrapper.text"></ap-content>
    </div>
    <ap-button type="button" variant="secondary" (onClick)="cancel()" data-bb="cancel">
        {{ 'mijn.login.browsercode.herstel.wrapper.cancel' | apContent }}
    </ap-button>
    <ap-button type="submit" variant="primary" (onClick)="changeBrowserCode()" data-bb="submit" [isDisabled]="changeBrowserCodeDisabled">
        {{ 'mijn.login.browsercode.herstel.wrapper.submit' | apContent }}
    </ap-button>
</mijn-login-template>
